function SSAudioVideoBar(config){
  if(typeof config === "undefined") {
    return;
  }
  this.config = config;
  this.resource = this.config.resource;
  this.RIGHT_PANEL_WIDTH = 0;
  this.TIMESTAMP_TOOLTIP_OFFSET = 5;
  this.$toolbar = $('.toolbar');
  this.TOOLBAR_PADDING_RIGHT = parseInt(this.$toolbar.css('padding-right'), 10);
  this.TOOLBAR_PADDING_LEFT = parseInt(this.$toolbar.css('padding-left'), 10);
  this._init();
}

SSAudioVideoBar.prototype._init = function(){
  this.container = $('<div/>').attr({
    "class" : "jspl_audiobar"
  }).css({
    display : 'none',
    height : this.config.height
  });
  this.container.prependTo(this.config.renderTo);
  this.container.append(this.config.html);

  var css2ConfettiContainer = this.config.renderTo;
  if (this.config.show_image_player) {
    css2ConfettiContainer = this.config.renderTo.parents(".player");
  }

  this.markers = this.container.find('.jspl_audiobar_markers');
  this.bufferProgress = this.container.find('.jspl_audiobar_progress .jspl_buffered');
  this.playProgress = this.container.find('.jspl_audiobar_progress .jspl_played');

  this.totalInfoElement = this.$toolbar.find('.j-video-length');
  this.progressInfoElement = this.$toolbar.find('.j-video-curr-time');
  this.$timeToolTip = this.container.find('.j-timestamp-tooltip');
  this.$timestampLabel = this.$timeToolTip.find('.j-timestamp-label');

  this.confetti = $('<img/>').attr({
    "class" : "jspl_css2_audioconfetti",
    "src" : this.config.css2ConfettiUrl
  }).appendTo(css2ConfettiContainer);

  this._getTime = this._getTimeHourRange; // removing hour check as now we want all time to be shown in hh:mm:ss format
  this.isTimestampTooltipStatic = false;
  this.renderSeekBar();
  this.deactivate();
};

SSAudioVideoBar.prototype.deactivate = function(){
  this._unbindEvents();
};

SSAudioVideoBar.prototype.setDimensions = function(dimensions, isMobileRequest){
  var that = this;
  if(!dimensions.width){
    return;
  }

  this.width = $('.toolbar').width() - (this.TOOLBAR_PADDING_LEFT + 
    this.TOOLBAR_PADDING_RIGHT + this.ACTIONS_WIDTH + parseInt($(this.container).css('left'), 10));
  // this adjustment is needed only for video player. Since the bar needs to come between the play and other actions.

  if(dimensions.fullscreen) {
    var leftOffset = $('.toolbar .nav').width();
    this.width = this.width - leftOffset;
    $(this.container).css({ width: this.width || dimensions.width, left: leftOffset });
  } else {
    $(this.container).css('width', this.width || dimensions.width);
  }

  // @todo optimize for performance here, major hit when window resizes by drag in non in_page fullscreen mode
  var leftPart = this.markers.parent(), partWidth;

  // used area is 85px for right info + 10 *2 padding for it and 10px padding on left
  if(this.width) {
    partWidth = this.width - parseInt($(leftPart).css('left'), 10);
  } else {
    // since container's width is not calculated, use padding of toolbar to adjust(reduce) the width
    partWidth = dimensions.width - 
    (parseInt($(leftPart).css('left'), 10) + this.TOOLBAR_PADDING_LEFT + this.TOOLBAR_PADDING_RIGHT);
  }
  leftPart.css('width', partWidth);

  this.videoPlayer && this.videoPlayer.resize(dimensions.width, dimensions.height);
  if(isMobileRequest) {
    $('video').css({
      width: dimensions.width,
      height: dimensions.height
    });
  }
};

SSAudioVideoBar.prototype.destroy = function(){
  this.container.remove();
};

SSAudioVideoBar.prototype._getTimeHourRange = function(seconds){
  var _formatTimeComponent = this._formatTimeComponent;
  seconds = seconds || 0;
  var hours = Math.floor(seconds/3600);
  seconds = seconds % 3600;
  return ( this.totalHours > 0 ? _formatTimeComponent(hours) + ':' : "") + this._getTimeMinuteRange(seconds);
};

SSAudioVideoBar.prototype._getTimeMinuteRange = function(seconds){
  var _formatTimeComponent = this._formatTimeComponent;
  seconds = seconds || 0;
  var minutes = Math.floor(seconds/60);
  seconds = seconds % 60;
  return _formatTimeComponent(minutes) + ':' + _formatTimeComponent(seconds);
};

SSAudioVideoBar.prototype._formatTimeComponent = function(number){
  var s = '' + number;
  var numberLen = s.length;
  var i;
  for (i=0; i<(2 - numberLen); i++){
    s = '0' + s;
  }
  return s;
};

SSAudioVideoBar.prototype._unbindEvents = function(){
  this.markers.find('.jspl_audioMarker').unbind('click').bind('click', function(e){
    e.preventDefault();
    e.stopPropagation();
  });
};

/**
 * updateProgress() updates the toolbar timestamp
 *
 * @param <Numeric> positionMSeconds - The position, in milliseconds, we are at
 *   in the video
 */
SSAudioVideoBar.prototype.updateProgress = function (positionMSeconds) {
  var positionSeconds = parseInt(positionMSeconds / 1000, 10);
  var percentPlayed = positionSeconds / this.totalLength * 100;

  this.playProgress.css('width', percentPlayed + '%');
  this.progressInfoElement.text(this._getTime(positionSeconds));
};

/**
 * updateToolTip() updates the location and text of the timestamp tooltip
 *
 * @param <Numeric> positionMSeconds - The position, in milliseconds, we are at
 *   in the video
 */
SSAudioVideoBar.prototype.updateToolTip = function (positionMSeconds) {
  var positionSeconds = parseInt(positionMSeconds / 1000,10);
  var percentPlayed = positionMSeconds / 1000 / this.totalLength * 100;
  var ttWidth = this.$timeToolTip.outerWidth();

  this.$timestampLabel.text(this._getTime(positionSeconds));
  this.$timeToolTip.css('left', percentPlayed + '%');
  // Extra -10px to account for the width of the cursor
  this.$timeToolTip.css('margin-left', -1 * ttWidth / 2 - 7.5);
  this.fitTooltipInWindow();
  this.$timeToolTip.show();
};

/**
 * fitTooltipInWindow() prevents the tooltip from going off the screen's edge
 */
SSAudioVideoBar.prototype.fitTooltipInWindow = function () {
  this.$timestampLabel.css({
    'margin-left': 0,
    'margin-right': 0
  });
  var leftX = this.$timestampLabel.offset().left;
  var rightX = leftX + this.$timeToolTip.width();
  var windowWidth = $(window).width();

  if (leftX < 0) {
    this.$timestampLabel.css('margin-left', leftX * - 1);
  } else if (rightX > windowWidth) {
    this.$timestampLabel.css('margin-left', (rightX - windowWidth) * - 1);
  }
};

/**
 * hideToolTip() hides the timestamp tooltip
 */
SSAudioVideoBar.prototype.hideToolTip = function () {
  this.$timeToolTip.hide();
};

SSAudioVideoBar.prototype.updateBuffer = function(positionms){
  var percentBuffered = positionms/1000/this.totalLength*100;
  this.bufferProgress.css('width', percentBuffered + '%');
};

export default SSAudioVideoBar;
